import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKey3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="key-3, password"><circle cx="16.5" cy="7.5" r="4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.50105 15.7139L10.4087 17.6215L8.02239 20.0078L6.0625 18.0479" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.25 10.75L3.5 20.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconKey3;
